export function toBRL(value: string | number) {
  if (typeof value === 'string') value = parseFloat(value);

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function toReadableNumber(value: string | number) {
  if (typeof value === 'string') value = parseFloat(value);

  return new Intl.NumberFormat('pt-BR').format(value);
}

export function toReadableDate(date: Date | string) {
  if (typeof date === 'string') date = new Date(date);

  return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

export function toCPF(value: string) {
  value = value.replace(/\D/g, '');
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function toCNPJ(value: string) {
  value = value.replace(/\D/g, '');
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function toDuration(totalInSeconds: number) {
  const hours = Math.floor(totalInSeconds / 3600);
  const minutes = Math.floor((totalInSeconds - hours * 3600) / 60);
  let seconds = Math.floor(totalInSeconds - 3600 * hours - 60 * minutes);

  if (seconds < 10) seconds = '0' + seconds;

  if (!hours) return `${minutes}:${seconds}`;

  return `${hours}:${minutes}:${seconds}`;
}

// Prefixos de serviço não geográfico (0800, 0300, 0500, 0900) — não são DDD.
const NON_GEOGRAPHIC = /^0?[3589]00/;

/**
 * Formata telefone BR enquanto digita, sem máscara fixa:
 * "+55 800 600 9988", "0800 600 9988", "(11) 9 9999-9999", "(11) 9999-9999".
 * O "+55" só é tratado como país quando digitado com "+" ou com mais de 11 dígitos
 * (55 também é DDD do RS).
 */
export function toPhone(value: string) {
  let digits = (value || '').replace(/\D/g, '');
  const hasCountry = /^\s*\+/.test(value || '') || (digits.length > 11 && digits.startsWith('55'));
  let prefix = '';

  if (hasCountry) {
    prefix = '+' + digits.slice(0, 2);
    digits = digits.slice(2);
    if (!digits) return prefix;
    prefix += ' ';
  }

  if (NON_GEOGRAPHIC.test(digits)) {
    const head = digits.startsWith('0') ? 4 : 3;
    digits = digits.slice(0, head + 7);
    return prefix + [digits.slice(0, head), digits.slice(head, head + 3), digits.slice(head + 3)].filter(Boolean).join(' ');
  }

  digits = digits.slice(0, 11);
  // Até 2 dígitos ainda pode virar 0800/800, então não abre o parêntese do DDD.
  if (digits.length <= 2) return prefix + digits;
  const ddd = `(${digits.slice(0, 2)}) `;
  const number = digits.slice(2);
  if (digits.length === 11) return prefix + ddd + `${number[0]} ${number.slice(1, 5)}-${number.slice(5)}`;
  if (number.length > 4) return prefix + ddd + `${number.slice(0, 4)}-${number.slice(4)}`;
  return prefix + ddd + number;
}
